import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import Tooltip from '@material-ui/core/Tooltip';
import { AppStyles } from '../styles/AppTheme';
import { Controller } from '../common/Controller';

export class BreadcrumbsHelper {
  static getRoutes(path) {
    const pathArray = path.split('/')
    const filtered = pathArray.filter(function (value) {
      return value.length > 0
    });
    const orgId = Controller.get().userMgr().getOrgId()
    console.log('filtered', filtered)

    if(filtered.length !== 0 && filtered[0] === 'places') {
      return [
        {
          title: 'Places',
          url: '/orgs/' + orgId + '/places'
        }
      ]
    }
    return []
  }
}



// WEBPACK FOOTER //
// ./src/helpers/BreadcrumbsHelper.js